import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const HelpLinkContext = /*#__PURE__*/createContext(undefined);
export const HelpLinkProvider = ({
  popoverStylesOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(HelpLinkContext.Provider, {
    value: {
      popoverStylesOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `HelpLink` component.
 * Note: The context is only available when the `HelpLink` component is rendered as an ancestor.
 * @returns HelpLinkContext - The context for the `HelpLink` component.
 * @returns HelpLinkContext.popoverStylesOverrides - Style overrides to be applied to the `Popover` component.
 */
export const usePopoverHelpLinkContext = () => {
  const helpLinkContext = useContext(HelpLinkContext);
  return helpLinkContext;
};